import { resolveImagePath } from '@/utils/imageResolver';

export function Hero() {
  return (
    <section className="relative">
      {/* Header Bar */}
      <div 
        className="relative bg-cream-base py-4 px-6"
        style={{
          backgroundImage: `url(${resolveImagePath('/images/header-overlay.png')})`,
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
          backgroundSize: 'cover'
        }}
      >
        <div className="max-w-7xl mx-auto flex items-center justify-between">
          {/* Navigation */}
          <nav className="flex space-x-8">
            <a 
              href="/" 
              className="text-black font-bebas text-xl font-bold uppercase tracking-wide hover:text-warm-gold transition-colors"
            >
              HOME
            </a>
            <a 
              href="/wp-content/uploads/Dianas-Morning-Brew-Menu.pdf" 
              className="text-black font-bebas text-xl font-bold uppercase tracking-wide hover:text-warm-gold transition-colors"
              target="_blank"
              rel="noopener noreferrer"
            >
              MENU
            </a>
          </nav>

          {/* Central Logo */}
          <div className="flex-1 flex justify-center">
            <img 
              src={resolveImagePath('/images/Logo-Dianas-Morning-Brew-300x158.png')}
              alt="Diana's Morning Brew - Tilton MA"
              className="h-16 w-auto"
            />
          </div>

          {/* Social Links & Phone */}
          <div className="flex items-center space-x-6">
            {/* Social Icons */}
            <div className="flex space-x-4">
              <a 
                href="https://www.facebook.com/DianasMorningBrew"
                target="_blank"
                rel="noopener noreferrer"
                className="text-secondary-gray hover:text-black transition-colors"
                aria-label="Facebook"
              >
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M20 10C20 4.477 15.523 0 10 0S0 4.477 0 10c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V10h2.54V7.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V10h2.773l-.443 2.89h-2.33v6.988C16.343 19.128 20 14.991 20 10z" clipRule="evenodd" />
                </svg>
              </a>
              <a 
                href="https://www.instagram.com/dianasmorningbrew"
                target="_blank"
                rel="noopener noreferrer"
                className="text-secondary-gray hover:text-black transition-colors"
                aria-label="Instagram"
              >
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M10 0C4.477 0 0 4.484 0 10.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.032 1.531 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0110 4.844c.85.004 1.705.115 2.504.337 1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.203 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.942.359.31.678.921.678 1.856 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.019 10.019 0 0020 10.017C20 4.484 15.522 0 10 0z" clipRule="evenodd" />
                </svg>
              </a>
              <a 
                href="https://www.yelp.com/biz/dianas-morning-brew-tilton"
                target="_blank"
                rel="noopener noreferrer"
                className="text-secondary-gray hover:text-black transition-colors"
                aria-label="Yelp"
              >
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M10 0C4.477 0 0 4.484 0 10.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.032 1.531 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0110 4.844c.85.004 1.705.115 2.504.337 1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.203 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.942.359.31.678.921.678 1.856 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.019 10.019 0 0020 10.017C20 4.484 15.522 0 10 0z"/>
                </svg>
              </a>
            </div>

            {/* Phone Number */}
            <a 
              href="tel:6037290297"
              className="text-black font-bebas text-lg font-bold hover:text-warm-gold transition-colors"
            >
              603.729.0297
            </a>
          </div>
        </div>
      </div>

      {/* Main Hero Section */}
      <div 
        className="relative bg-black py-24"
        style={{
          backgroundImage: `url(${resolveImagePath('/images/hero-background.jpg')})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat'
        }}
      >
        {/* Dark overlay for better text contrast */}
        <div className="absolute inset-0 bg-black bg-opacity-60"></div>
        
        <div className="relative max-w-4xl mx-auto text-center px-6">
          {/* Tagline */}
          <p className="text-bright-yellow font-carattere text-4xl mb-8">
            Come Out of Your Shell @
          </p>

          {/* Main Logo */}
          <div className="mb-12">
            <img 
              src={resolveImagePath('/images/Logo-Dianas-Morning-Brew.png')}
              alt="Diana's Morning Brew - Tilton MA"
              className="mx-auto w-80 h-auto"
            />
          </div>

          {/* CTA Button */}
          <a 
            href="/wp-content/uploads/Dianas-Morning-Brew-Menu.pdf"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block bg-light-blue hover:bg-blue-600 text-white font-bebas text-lg font-bold px-8 py-3 rounded transition-colors duration-300 uppercase tracking-wide"
          >
            View Menu
          </a>
        </div>
      </div>

      {/* Bottom Section */}
      <div className="bg-warm-cream py-16">
        <div className="max-w-7xl mx-auto text-center px-6">
          <h2 className="font-bebas text-4xl font-bold text-black uppercase tracking-wide">
            Enjoy fresh brewed New Hampshire coffee
          </h2>
        </div>
      </div>
    </section>
  );
}